import './App.css';
import SignUp from './components/Signup';

function App() {
  return (
    <div className="App">
      <SignUp></SignUp>
    </div>
  );
}

export default App;
